<template>
  <v-dialog
    lazy
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
    v-bind:style="{ zIndex: options.zIndex }"
    :persistent="true"
    content-class="custom-dialog"
  >
    <v-card>
      <v-toolbar :color="options.color" dense flat>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="cancel">
            <v-icon color="#E0E0E0">close</v-icon>
          </v-btn>
        </v-toolbar-items>

      </v-toolbar>
      <div v-if="type === 'accentTest'" class="accentTest pl-4 pr-4 pb-4 blue-title">
          <p class="t1">Your accent has been detected as：</p>
          <p class="title">{{ message }}</p>
          

          <p class="custom-icon" :class="message">
          </p>
        
      </div>
      <div v-else>
        <p class = "custom-icon">
          <!-- <v-icon :class="options.msgIconColor">{{ options.msgIcon }}</v-icon> -->
          <v-icon color="#EE344C">{{ options.msgIcon }}</v-icon>
        </p>
        <v-card-text class ='align-center blue-title' v-show="!!message" v-html="message">{{ message }}</v-card-text>
        <div class="custom-footer">
          <v-btn class="text-none red-button height-28" :disabled = "options.btnDiabled" @click.native="cancel" round>{{ options.btnText }}</v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    message: null,
    type: 'default',
    options: {
        color: 'white',
        width: 400,
        zIndex: 200,
        btnText: 'Confirm',
        btnDiabled: false,
        msgIcon: 'cancel',
        msgIconColor: ''  //默认红色
    },
    LimitFlowOptions: {
      visibleSeconds: 3,
      btnText: 'OK',
      msgIcon: 'warning',
      msgIconColor: 'yellows'

    }


  }),
  methods: {
    cancel () {
      this.dialog = false
    }
  },
  watch: {
    dialog (val) {
      if (val && this.type === 'LimitFlow'){
        this.options.msgIcon = this.LimitFlowOptions.msgIcon
        this.options.msgIconColor = this.LimitFlowOptions.msgIconColor
        let visibleTime = this.LimitFlowOptions.visibleSeconds
        this.options.btnDiabled = true
        this.options.btnText = visibleTime + ' S';
        var timer = setInterval(() => {
            visibleTime--
            this.options.btnText = visibleTime + ' S';
            if (visibleTime < 0) {
                clearInterval(timer);
                this.options.btnText = 'OK';
                this.message = 'You can have a try again now.'
                this.options.btnDiabled = false
            }
        }, 1000)

      }
      if(val && this.type == 'lotterySuccess'){
        this.options.msgIcon = 'attach_money'
        this.options.btnText = 'Confirm'
        this.options.msgIconColor = 'lotterySuccess'
        this.options.btnDiabled = false
      }
      if(val && this.type == 'lotteryFailed'){
        this.options.msgIcon = ''
        this.options.btnText = 'Confirm'
        this.options.msgIconColor = 'lotteryFailed'
        this.options.btnDiabled = false
      }
      if(val && this.type == 'lotteryWarning'){
        this.options.msgIcon = 'warning'
        this.options.btnText = 'Confirm'
        this.options.msgIconColor = 'lotteryWarning'
        this.options.btnDiabled = false
      }
      if(val && this.type == 'accentTest'){
        this.options.msgIcon = 'cancel'
        this.options.btnText = 'Confirm'
        this.options.msgIconColor = ''
        this.options.btnDiabled = false
      }
      if(val && this.type == "default") {
        this.options.msgIcon = 'cancel'
        this.options.btnText = 'Confirm'
        this.options.msgIconColor = ''
        this.options.btnDiabled = false
      }
    }
  }
}
</script>
<style>
  .custom-dialog{
    border-radius: 8px;
    overflow: hidden;
  }
  .custom-dialog .theme--dark.v-btn{
    color: gray;
  }
  .custom-dialog .v-toolbar__content, .custom-dialog .v-toolbar__extension{
    padding: 0;
  }
  .custom-dialog .v-card__text{
    /* font-weight: bold; */
    font-size: 16px;
  }
  .custom-dialog .v-card__text.align-center{
    text-align: center;
  }
  .custom-dialog .v-card__text.align-left{
    text-align: left;
  }
  .custom-dialog .custom-icon{
    text-align: center;
    margin-bottom: 0;
  }
  .custom-dialog .custom-icon .v-icon{
    /* color: red; */
    font-size: 40px;
    width: 40px;
    height: 40px;
    display: inline-block;
  }
  .custom-dialog .custom-icon .v-icon.yellows{
    color: #ffd351
  }
  .custom-dialog .custom-icon .v-icon.lotterySuccess{
    background: #26885d;
    color: #fff;
    border-radius: 50%;
  }
  .custom-dialog .custom-icon .v-icon.lotteryFailed{
    color: #fb8f36;
    background: url(~@/assets/img/lottery/cry.png) no-repeat;
    background-size: 100%;
  }
  .custom-dialog .custom-icon .v-icon.lotteryWarning{
    color: #ff5555;
  }
  .custom-dialog .v-btn{
    padding: 0 25px
  }
  .custom-dialog .custom-footer{
    text-align: center;
    padding: 10px 0 20px;
  }
  .custom-dialog .custom-footer .v-btn--outline{
    color: #000;
  }
  .accentTest .t1{
    font-size: 16px;
  }
  .accentTest .title{
    text-align: center;
  }
  .accentTest .accent{
    margin: 0 auto;
    height: 100px;
    width: 100px;
  }
  .accentTest .American.accent{
    background-image: url(~@/assets/img/accentType/accent1.png);
    background-color: #fff!important;
    background-size: 100%;
  }
  .accentTest .British.accent{
    background-image: url(~@/assets/img/accentType/accent2.png);
    background-color: #fff!important;
    background-size: 100%;
  }
  .accentTest .Filipino.accent{
    background-image: url(~@/assets/img/accentType/accent3.png);
    background-color: #fff!important;
    background-size: 100%;
  }
  .height-28{
    height:28px;
  }

</style>
